module.exports = __webpack_public_path__ + "img/kaymunrahs_weapon.04357b11.jpg";